import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { RuleActionsUnion, RuleActionTypes } from '@core/actions/rule.actions';
import { comparerByNumber } from '@app/comparers';
import { AuthActionsUnion, AuthActionTypes } from '../actions/auth.actions';
import { createSelector, createFeatureSelector } from '@ngrx/store';
export interface State {
  rules: any;
  loading: boolean;
  loaded: boolean;
}

// export const adapter: EntityAdapter<Rule> = createEntityAdapter<Rule>({
//   selectId: (product: Rule) => product.id,
//   sortComparer: comparerByNumber('ASC', 'code')
// });

export const INITIAL_STATE: State = {
  rules: {},
  loaded: false,
  loading: false
};

export function reducer(
  state: State = INITIAL_STATE,
  action: RuleActionsUnion
) {
  switch (action.type) {
    case RuleActionTypes.Load:
      return { ...state, loading: true };

    case RuleActionTypes.LoadFail:
      return { ...state, loading: false };

    case RuleActionTypes.LoadSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        rules: action.rules
      };

    default:
      return state;
  }
}

const getState = createFeatureSelector<State>('rules');

export const getLoaded = createSelector(
  getState,
  (state: State) => state.loaded
);
export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);
export const getRules = createSelector(
  getState,
  (state: State) => state.rules
);
